export default __webpack_public_path__ + "static/media/pullover.7b178868.png";